/**
 * 预览子组件-操作栏组件
 * @author chenqunfeng
 * @since 18/06/07
 */

import './operation-bar.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flyTo } from 'utils/animation';
import { showRabbitBrandInfo } from 'utils/user';
import { pushFiboTemplateCollect } from 'utils/statisticSDK';

import VARIABLE from 'constants/variable.json5';

class PreviewOperation extends Component {
  static propTypes = {
    data: PropTypes.object,
    userInfo: PropTypes.object,
    newClassName: PropTypes.string,
    setTplCollectionStatus: PropTypes.func,
  };

  // 取消收藏
  cancel() {
    const { data, userInfo, setTplCollectionStatus } = this.props;
    const { id, title, tplPrice } = data;
    const { userId, organizeId } = userInfo;

    if (!userId) {
      const showSSODialog = window.COMMON_NAVBAR.showSSODialog;
      showSSODialog && showSSODialog('login', true);
    } else {
      setTplCollectionStatus(userId, organizeId, id, false);
      pushFiboTemplateCollect({ type: 0, title, tplPrice });
    }
  }

  // 确认收藏
  confirm() {
    const { data, userInfo, setTplCollectionStatus } = this.props;
    const { id, title, tplPrice, pluginId } = data;
    const { userId, organizeId } = userInfo;

    if (!userId) {
      const showSSODialog = window.COMMON_NAVBAR.showSSODialog;
      showSSODialog && showSSODialog('login', true);
    } else {
      flyTo(this.like, document.querySelector('.nav-collection'), {
        initStyle: {
          color: '#ff4534',
          'z-index': 100,
        },
      });
      setTplCollectionStatus(userId, organizeId, id, true);
      pushFiboTemplateCollect({
        type: 1,
        title,
        tplPrice,
        isPluginType: pluginId,
      });
    }
  }

  // 复制链接
  copyUrl() {
    this.clipboard.select();
    try {
      const result = document.execCommand('copy');
      if (result) {
        this.copySuccess();
      } else {
        this.copyFailed();
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 复制成功提示
  copySuccess() {
    this.copyBtn &&
      this.copyBtn.classList &&
      this.copyBtn.classList.add('s-copy-success-tips');
    setTimeout(() => {
      this.copyBtn &&
        this.copyBtn.classList &&
        this.copyBtn.classList.remove('s-copy-success-tips');
    }, 1666);
  }

  // 复制失败提示
  copyFailed() {
    this.copyBtn &&
      this.copyBtn.classList &&
      this.copyBtn.classList.add('s-copy-failed-tips');
    setTimeout(() => {
      this.copyBtn &&
        this.copyBtn.classList &&
        this.copyBtn.classList.remove('s-copy-failed-tips');
    }, 1666);
  }

  // 获取浏览量HTML模版
  // 因为一视模版没有统计浏览量,所以针对一视模版,显示为使用量
  getViewCount() {
    const { tplViewcount, tplAmount, category, type } = this.props.data;

    if (category === VARIABLE.ENTERPRISE) {
      return null;
    } else {
      return (
        <span className="s-view-count-container">
          {type !== VARIABLE.POSTER && <span className="s-icon icon-look" />}
          {type === VARIABLE.RP_VIDEO ? (
            <span className="s-preview-view-count">
              使用量：
              {tplAmount || 0}
            </span>
          ) : (
            type !== VARIABLE.POSTER && (
              <span className="s-preview-view-count">{tplViewcount || 0}</span>
            )
          )}
        </span>
      );
    }
  }

  // 获取复制链接HTML模版
  getCopyUrl() {
    const { id, type, category, platformTemplate } = this.props.data;
    const host = location.host;
    let path = window.location.pathname;
    // 模板市场页面路由
    const pathStoreUrl = '/template/';
    const paths = [
      '/chajian/',
      '/template/',
      '/template/recommend.html',
      '/template/store.html',
      '/template/multipage.html',
      '/template/longpage.html',
      '/template/shortvideo.html',
    ];

    // 若是在模版市场复制链接,则有对应的tab对应;若不是,则不对应到对应的tab,只指向/recommend
    if (paths.indexOf(path) === -1) {
      path = pathStoreUrl;
    } else {
      path = `${path}`;
    }
    if (category === VARIABLE.ENTERPRISE) {
      return null;
    } else {
      return (
        <>
          {platformTemplate ? null : showRabbitBrandInfo() ? (
            <span
              className="s-copy-container"
              onClick={this.copyUrl.bind(this)}>
              <span className="s-icon icon-link" />
              <span
                className="s-preview-copy-url"
                ref={copyBtn => (this.copyBtn = copyBtn)}>
                复制链接
              </span>
              <input
                className="s-clipboard"
                ref={clipboard => (this.clipboard = clipboard)}
                defaultValue={`${host}${path}#${id}#${type}#${category}`}
              />
            </span>
          ) : null}
        </>
      );
    }
  }

  // 获取收藏HTML模版
  getCollection() {
    const { data } = this.props;
    const { isCollectionTpl, category } = data;

    if (category === VARIABLE.ENTERPRISE || category === VARIABLE.MY_TPL) {
      return null;
    }

    if (!isCollectionTpl) {
      return (
        <span
          className="s-collection-container"
          onClick={this.confirm.bind(this)}>
          <span
            ref={like => (this.like = like)}
            className="s-icon s-icon-uncollect icon-collect2"
          />
          <span className="s-preview-shoucang">收藏</span>
        </span>
      );
    } else {
      return (
        <span
          className="s-collection-container"
          onClick={this.cancel.bind(this)}>
          <span
            ref={like => (this.like = like)}
            className="s-icon s-icon-collect icon-collect2"
          />
          <span className="s-preview-shoucang">已收藏</span>
        </span>
      );
    }
  }

  render() {
    let { data, newClassName = '' } = this.props;
    const { category } = data;

    if (category === VARIABLE.MY_TPL) {
      return null;
    }

    if (category === VARIABLE.ENTERPRISE) {
      newClassName += ' s-preview-enterprise';
    }

    return (
      <div className={`s-preview-operation ${newClassName}`}>
        {this.getViewCount()}
        {this.getCopyUrl()}
        {this.getCollection()}
      </div>
    );
  }
}

export default PreviewOperation;
